import {RefObject} from 'react';

// DOM layout 연산에서 제외된 경우를 말한다 (opacity 0 와 같이 단순히 안보이는 상황 X)
export function getIsDetachedElement(el: HTMLElement): boolean {
  // 참고 링크: https://github.com/jquery/jquery/blob/025da4dd343e6734f3d3c1b4785b1548498115d8/src/css/hiddenVisibleSelectors.js
  return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function* getAncestors(startEl: HTMLElement | null, isIncludeStart?: boolean) {
  let currentEl = isIncludeStart ? startEl : startEl?.parentElement;
  while (currentEl) {
    yield currentEl;
    currentEl = currentEl.parentElement;
  }
  return;
}

export function tryUpdateHiddenElement(
  element: RefObject<HTMLElement> | HTMLElement,
  onUpdate: () => void | undefined
): (() => void) | undefined {
  const el = 'current' in element ? element.current : element;
  if (!el) return;

  let observer: MutationObserver | undefined;
  function setUpdateElement() {
    let hiddenEl: HTMLElement | null = null;
    if (el && !getIsDetachedElement(el)) {
      onUpdate();
    } else {
      for (const _el of getAncestors(el, true)) {
        if (window.getComputedStyle(_el).display === 'none') {
          hiddenEl = _el;
          break;
        }
      }
      if (hiddenEl) {
        observer = new MutationObserver(() => {
          if (
            hiddenEl &&
            window.getComputedStyle(hiddenEl).display !== 'none'
          ) {
            observer?.disconnect();
            setUpdateElement();
          }
        });
        observer.observe(hiddenEl, {attributeFilter: ['class', 'style']});
      }
    }
  }
  setUpdateElement();
  return observer ? () => observer?.disconnect() : undefined;
}
